/**
 * THE WOLFE - Shopify Theme JavaScript
 * Handles: Navbar scroll, mobile menu, scroll animations
 */

// --- Navbar Scroll Effect ---
(function() {
  const nav = document.getElementById('site-nav');
  if (!nav) return;

  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        if (window.scrollY > 40) {
          nav.classList.add('scrolled');
        } else {
          nav.classList.remove('scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  });
})();

// --- Mobile Menu Toggle ---
function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const menuIcon = document.querySelector('.icon-menu');
  const closeIcon = document.querySelector('.icon-close');

  if (!menu) return;

  menu.classList.toggle('open');

  if (menuIcon && closeIcon) {
    menuIcon.classList.toggle('hidden');
    closeIcon.classList.toggle('hidden');
  }
}

// --- Scroll Animations (Intersection Observer) ---
(function() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animatedElements = document.querySelectorAll('.fade-in, .fade-in-left, .fade-in-right, .scale-in');

  if (!animatedElements.length) return;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '-50px'
  });

  animatedElements.forEach(function(el) {
    observer.observe(el);
  });
})();

// --- Smooth Scroll for Anchor Links ---
(function() {
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;

      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        const navHeight = document.getElementById('site-nav')?.offsetHeight || 80;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - navHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
})();
